<template>
    <div class="app">
        <Navigation />

        <main v-if="!user">
            <login>
                <template v-slot:title>My songs</template>
                <template v-slot:text>Login to save gear's presets.</template>
            </login>
        </main>

        <main v-if="user">

            <div class="app__title">
                <h1>My songs</h1>

                <button @click="addSongModal()" class="button button--icon" v-b-tooltip.hover title="Add song">
                    <i class="las la-plus"></i>
                </button>
            </div>

            <div v-if="mySongs.length">
                <div v-for="song in mySongs" :key="song.id" class="song__item">
                
                    <router-link :to="'/songs/'+song.id">
                        {{ song.artist }} - {{ song.title }}
                    </router-link>
                    
                    <div class="song__item__gear">
                        <span class="song__item__gear__item" v-for="gear in song.gear" :key="gear.gearId">
                            <GearImage :gearId="gear.gearId"/>
                        </span>
                    </div>

                    <div class="song__item__options">
                        <b-dropdown toggle-class="button button--icon button--ghost" :id="'gearItemDropdown-'+song.id" no-caret>
                            <template #button-content>
                                <i class="las la-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item>Edit</b-dropdown-item>
                            <b-dropdown-item @click="deleteSong(song.id)">Delete</b-dropdown-item>
                        </b-dropdown>
                    </div>

                </div>
            </div>

            <div v-else class="empty-message">
                <span>🎛</span>
                <h2>Start adding songs</h2>
                <p>You don't have any songs. Create a song, link your gear to it and save the presets of your gear!</p>
                <button class="button button--green" @click="addSongModal()">Add a song</button>
            </div>

            <div class="overlay" v-if="showAddSongModal">

                <div class="overlay__holder">
                    <div class="overlay__title">
                        <strong>New song</strong>
                        <div class="overlay__close" @click="showAddSongModal = false">&times;</div>
                    </div>

                    <div class="overlay__content">
                        <input placeholder="Song title" type="text" v-model="newSong.title"/>
                        <input placeholder="Song artist" type="text" v-model="newSong.artist"/>

                        <div v-if="user">

                            <div class="gear__select" @click="addMyGear(item.id)" v-for="(gear, index) in user.gear" :key="index">
                                <label>
                                    <input type="checkbox" v-model="newSong.gear" name="gear" :value="gear.gearId" />
                                    <div class="gear__select__image">
                                        <GearImage :gearId="gear.gearId" />
                                    </div>
                                    <GearTitle :gearId="gear.gearId" />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="overlay__footer">
                        <button class="button" @click="addSong()">Add new song</button>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Navigation from "@/components/Nav";
import { mapState } from 'vuex'
import GearTitle from "./GearTitle.vue";
import Login from './Login.vue';
import GearImage from "./GearImage.vue";

export default {
    data() {
        return {
            showAddSongModal: false,
            newSong: { title: null, artist: null, gear: [] },
        };
    },
    computed: {
        ...mapState(['gear', 'user', 'mySongs'])
    },
    components: { Navigation, GearTitle, Login, GearImage },
    methods: {
        addSongModal: function() {
            this.showAddSongModal = true;
        },

        addSong: function() {
            for(var i=0; i<=this.newSong.gear.length-1; i++) {
                var found = this.gear.find((item) => item.id === this.newSong.gear[i])
                var knobs = found.knobs

                this.newSong.gear[i] = { gearId : this.newSong.gear[i], knobs: [] }

                for(var k=0; k<=knobs.length-1;k++) {
                    this.newSong.gear[i].knobs[k] = {
                        id: knobs[k].id,
                        value: null
                    }
                }
            }
            this.$store.dispatch('addSong', this.newSong)
            this.newSong = { title: null, artist: null, gear: [] }
            this.showAddSongModal = false
        },

        deleteSong: function(songId){
            this.$store.dispatch('deleteSong', songId)
        }
    },
    created() {
    },
    destroyed() {
    },
}
</script>